const availability = {
  container: document.getElementById("availability-results"),
  input: document.getElementById("availability-query"),
  loading: document.getElementById("availability-loading"),
  nearbyStores: [],
  search: async() => {
    availability.container.innerHTML = "";
    availability.loading.classList.remove("hidden");
    const input = availability.input.value.trim().toLowerCase();
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${input}+shasa+mexico&key=AIzaSyDUKMc8e0t3w-qczSev3CHlQtUnUgkXtbU`;
    const response = await fetch(url);
    const place = await response.json();
    if (place.status === "OK" && place.results.length > 0) {
      const coords = {
        latitude: place.results[0].geometry.location.lat,
        longitude: place.results[0].geometry.location.lng
      }
      for (const store of shasaStores) {
        store.distance = Math.abs(store.latitude - coords.latitude) + Math.abs(store.longitude - coords.longitude);
      }
      shasaStores.sort((a, b) => a.distance - b.distance);
      availability.nearbyStores = [
        shasaStores[0],
        shasaStores[1],
        shasaStores[2]
      ];
      availability.get();
    }
  },
  get: async () => {
    const products = [];
    for (const variant of product.variants) {
      const product = {
        // sku: variant.sku,
        ItemId: variant.sku.substring(0, 7),
        VariantId: variant.sku.substring(8),
        title: variant.title
      }
      products.push(product);
    }
    let storesWithInventory = 0;
    for (const store of availability.nearbyStores) {
      const inventory = {
        storeId: store.code,
        items: products
      }
      // const items = [];
      // for (const product of inventory.products) {
      //   const item = {
      //     ItemId: product.sku.substring(0, 7),
      //     VariantId: product.sku.substring(8),
      //   };
      //   items.push(item);
      // }
      // console.log(items);
      // const body = {
      //   items: inventory.products,
      //   storeId: inventory.storeId,
      // };
      const req = await fetch(
        "https://shapi-management.azure-api.net/Inventory/v1/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": "f6ae36cf8cda4fc19fe7faefbe1906e8",
          },
          body: JSON.stringify(inventory),
        },
      );
      const res = await req.json();
      inventory.total = 0;
      for (const item of res.ItemsInStoreGetResult) {
        // const sku = `${item.ItemId}_${item.VariantId}`;
        const current = inventory.items.find((p) => p.ItemId === item.ItemId && p.VariantId === item.VariantId);
        current.quantity = parseInt(item.QtyInventory);
        if (current.quantity > 0) inventory.total++;
      }

      const results = inventory;
      if (results.total > 1) {
        storesWithInventory++;
        const container = document.createElement("div");
        const storeInfo = document.createElement("div");
        const sizesContainer = document.createElement("div");
        sizesContainer.className = "flex";
        const sizes = document.createElement("div");
        sizes.className = "flex";
        // <p>${Math.round((store.distance * 157) * 10) / 10}km</p>
        storeInfo.innerHTML = `
          <div class="h5 flex justify-between">
            <p>${store.name}</p>
          </div>
          <div><p>${store.address}</p></div>
        `;
        container.appendChild(storeInfo);
        sizesContainer.appendChild(sizes);
        container.appendChild(sizesContainer);
        for (const product of results.items) {
          // let inventoryClass = "unavailable";
          // product.quantity > 0 && product.quantity < 6 ? inventoryClass = "low" : product.quantity > 5 ? inventoryClass = "available" : inventoryClass = "unavailable";
          // sizes.innerHTML += `<div class="pills-variant-labels ${inventoryClass}">${product.title}</div>`;
          if (product.quantity > 0) {
            sizes.innerHTML += `<div class="pills-variant-labels">${product.title}</div>`;
          }
        }
        availability.container.appendChild(container);
      }
    }
    availability.loading.classList.add("hidden");
    if (storesWithInventory < 1) {
      availability.container.innerHTML = "<h5 class='h5 text-center'>Sin inventario disponible cerca de tu ubicación</h5>";
    }
  },
  expand: ()=>{
    if (availability.container.childNodes.length == 0) {
      navigator.geolocation.getCurrentPosition((position) => {
        coords = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        }
        for (const store of shasaStores) {
          store.distance = Math.abs(store.latitude - coords.latitude) + Math.abs(store.longitude - coords.longitude);
        }
        shasaStores.sort((a, b) => a.distance - b.distance);
        availability.nearbyStores.push(shasaStores[0]);
        availability.get();
      });
    }
  }
}

availability.input.addEventListener("keyup", (e) => {
  if (e.key == "Enter") {
    availability.search();
  }
})